import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bsb',
  standalone: true
})
export class BsbPipe implements PipeTransform {
  transform(value: string | null | undefined): unknown {
    return BsbPipe.formatValue(value);
  }

  static formatValue(value: string | null | undefined): string {
    if (value && value.length == 6) {

      return [
        value.substring(0, 3),
        value.substring(3)
      ]
        .join(' ');
    }

    return '';
  }
}
